var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hero-thanks"},[_c('div',{staticClass:"hero-inner container"},[_c('div',{staticClass:"hero-text"},[_c('h1',[_vm._v(_vm._s(_vm.header))]),_c('p',{staticClass:"mb-2rem"},[_vm._v(" "+_vm._s(_vm.paragraph)+" ")])]),_c('div',{staticClass:"sunheroimage"},[_c('img',{attrs:{"src":_vm.imageSource,"alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }